// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar_container{width:25%;height:auto;min-height:90vh;background-color:#f9f9f9;box-shadow:3px 0 5px 0 rgba(0,0,0,0.1)}.sidebar_content_container{padding:25px;margin-top:40px}.sidebar_header{padding:10px}.sidebar_logout{float:right;cursor:pointer;font-size:12px}.sidebar_content{padding:10px}\n", ""]);
// Exports
module.exports = exports;
